// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"190":"0c5f4421","290":"ebc34e84","566":"d553e92a","679":"250c8ad8","709":"5a000b78","710":"0f167055","909":"b7fbc56a"}[chunkId] + ".js";
};